import { yupResolver } from '@hookform/resolvers/yup';
import { useContext, useEffect, useState } from 'react';
import { useFieldArray, useForm } from 'react-hook-form';
import * as yup from 'yup';
import { CabinetContext } from '../../context';
import { SET_FORM, SET_STEP } from '../../context/types';
import { $http } from '../../../../plugins';

export default () => {
  const {
    dispatch,
    state: { form, step }
  } = useContext(CabinetContext);
  const [areas, setAreas] = useState([{ label: '', value: '' }]);
  const [servicePoint, setServicePoint] = useState([{ label: '', value: '' }]);
  const [searchArea, setSearchArea] = useState('');

  const schema = yup.object({
    areaList: yup.array().of(
      yup.object().shape({
        areaId: yup.object().required('الحقل مطلوب').nullable(),
        fdtList: yup
          .array()
          .min(1, 'الحد الأدنى 1')
          .required('الحقل مطلوب')
          .of(yup.object().required('الحقل مطلوب').nullable()),
        towersCount: yup
          .number()
          .typeError('الحقل مطلوب')
          .required('الحقل مطلوب')
          .min(1, 'الحد الأدنى 1'),
        subsCount: yup
          .number()
          .typeError('الحقل مطلوب')
          .required('الحقل مطلوب')
          .min(1, 'الحد الأدنى 1'),
        MarketingPlan: yup.object().required('الحقل مطلوب'),
        DeploymentPlan: yup.object().required('الحقل مطلوب'),
        DeploymentPlanBolean: yup.bool().oneOf([true], 'يجب الموافقة على الشروط والأحكام'),
        MaintenancePlan: yup.object().required('الحقل مطلوب')
      })
    )
  });
  const {
    register,
    handleSubmit,
    control,
    setValue,
    setError,
    watch,
    formState: { errors },
    getValues: formData
  } = useForm({
    mode: 'onBlur',
    resolver: yupResolver(schema),
    defaultValues: {
      areaList: form?.areaList
    }
  });
  const { fields, append, remove } = useFieldArray({
    control,
    name: 'areaList'
  });

  const onSubmit = handleSubmit(async (data) => {
    dispatch({ type: SET_FORM, payload: data });
    dispatch({ type: SET_STEP, payload: 3 });
  });
  const goBack = () => {
    dispatch({ type: SET_STEP, payload: step - 1 });
  };
  const [governorate, setGovernorate] = useState('');

  useEffect(() => {
    $http
      .get(`/MasterData/Area/GetAutoCompleteForSubmission/${governorate}?term=${searchArea}`)
      .then((res) => {
        setAreas(
          res.data.map((d) => {
            return {
              label: d.value,
              value: d.key
            };
          })
        );
      });
  }, [searchArea, governorate]);

  return {
    register,
    control,
    errors,
    onSubmit,
    form,
    setValue,
    goBack,
    step,
    areas,
    dispatch,
    setSearchArea,
    fields,
    append,
    remove,
    servicePoint,
    formData,
    setGovernorate,
    watch
  };
};
